import cn from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import useRootElement from '../../hooks/useRootElement';
import Button from '../Button';
import styles from './ErrorOverlay.module.css';

interface ErrorOverlayProps {
  isLoading?: boolean;
  title: string;
  image: string;
  description: string;
  buttonText?: string;
  onClick?: () => void;
  animate?: boolean;
  isWebview: boolean;
}

const HIDE_IMAGE_HEIGHT = 360;

export const ErrorOverlay: React.FC<ErrorOverlayProps> = ({
  image,
  title,
  description,
  buttonText,
  onClick,
  animate,
  isLoading,
  isWebview,
}) => {
  const { element } = useRootElement();

  return ReactDOM.createPortal(
    <div className={cn(styles.layout, isWebview && styles.webview)}>
      {element.clientHeight >= HIDE_IMAGE_HEIGHT && (
        <img className={styles.image} src={image} alt="Тут должна быть красивая картинка ошибки" />
      )}
      <div className={animate ? styles.errorMessageAnim : styles.errorMessage}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
      </div>

      {buttonText && (
        <Button onClick={onClick} className={styles.button} isLoading={isLoading}>
          {buttonText}
        </Button>
      )}
    </div>,
    element,
  );
};
